import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TableUser } from './table-user';
import { BulkUserUploadModal } from './modal';
import { BreadCrumb } from '../common/breadcrumb';
import api from '../../services/axios';
import Swal from "sweetalert2";
import AddNewPop from '../common/add-new-pop';
import BulkAccess from './bulk-access/index';
import { Modal, ModalBody, ModalFooter, ModalHeader } from "../common/modal";

export const UserManagement = () => {
    const excelFilePath = '/Assets/Template.xlsx';
    const [selectedRowsData, setSelectedRowsData] = useState([]); // Update This
    const [bulkModal, setBulkModal] = useState(false); // Update this
    const [tableRefresh, setTableRefresh] = useState(false); // Update this
    const [changeSelectedData, setChangeSelectedData] = useState(false); // Update this
    const [modalBulkAccess, setModalBulkAccess] = useState({
        isOpen: false, selectedUser: null
    });
    const [resetPwItem, setResetPwItem] = useState(null);
    const [isResetPwModalOpen, setIsResetPwModalOpen] = useState(false);
    const [passwordRegexError, setPasswordRegexError] = useState(false);
    const [subBtnDisabled, setSubBtnDisabled] = useState(false);
    const [passwordInputValue, setPasswordInputValue] = useState('');
    const navigate = useNavigate();

    const navigateToAdd = () => {
        navigate('/AddUser');
    };

    const onRowsSelected = (data) => {
        setSelectedRowsData(data)
    }

    const handleDeleteButtonClick = () => {

        if (selectedRowsData.length === 0) {
            Swal.fire({
                position: "center",
                text: "Select atleast 1 user to delete",
                confirmButtonText: "Ok",
                timer: 3000,
                icon: 'info',
                timerProgressBar: true
            })
        }
        else {
            Swal.fire({
                text: 'Do you want to delete the selected user?',
                confirmButtonText: 'Delete',
                icon: 'warning',
                showDenyButton: true,
                denyButtonText: 'Cancel',
                customClass: {
                    actions: 'my-actions',
                    cancelButton: 'order-2 right-gap',
                    confirmButton: 'order-1',
                    denyButton: 'order-3',
                },
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        const { data } = await api.post('/User/BulkuserDelete', {
                            commands: selectedRowsData,
                        });
                        if (data.statusCode === 200) {
                            Swal.fire({
                                position: "center",
                                icon: 'info',
                                text: "Users deleted successfully",
                                confirmButtonText: "Ok",
                                timer: 3000,
                                timerProgressBar: true
                            })
                            setTableRefresh(!tableRefresh);
                            setChangeSelectedData(!changeSelectedData)
                        }
                    } catch (error) {
                        console.error('Error fetching data:', error);
                    }
                }
            })
        }

    };

    const handleDactivateButtonClick = () => {
        if (selectedRowsData.length === 0) {
            Swal.fire({
                position: "center",
                text: "Select atleast 1 user to deactivate",
                icon: 'info',
                confirmButtonText: "Ok",
            })
        }
        else {
            Swal.fire({
                text: 'Do you want to deactivate / activate the selected users?',
                confirmButtonText: 'Deactivate/Activate',
                showDenyButton: true,
                icon: 'info',
                denyButtonText: 'Cancel',
                customClass: {
                    actions: 'my-actions',
                    cancelButton: 'order-2 right-gap',
                    confirmButton: 'order-1',
                    denyButton: 'order-3',
                },
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        const { data } = await api.post('/User/BulkUserActivateDeActivate', {
                            commands: selectedRowsData,
                        });
                        if (data.statusCode === 200) {
                            Swal.fire({
                                position: "center",
                                text: 'Users Status Changed Successfully!',
                                icon: 'info',
                                confirmButtonText: "Ok",
                                timer: 3000,
                                timerProgressBar: true
                            })
                            setTableRefresh(!tableRefresh);
                            setChangeSelectedData(!changeSelectedData)
                        }
                    } catch (error) {
                        console.error('Error fetching data:', error);
                    }
                }
            })
        }
    };

    const setModalBulkAccessProps = (isOpen, selectedRowsData) => {
        if (selectedRowsData != null) {
            if (selectedRowsData.length === 0) {
                Swal.fire({
                    position: "center",
                    text: 'Please select at least one user',
                    icon: 'info',
                    confirmButtonText: "Ok",
                    timer: 3000,
                    timerProgressBar: true
                })
            }
            else {
                setModalBulkAccess({
                    isOpen, selectedUser: selectedRowsData
                })
            }
        }
        else {
            setModalBulkAccess({
                isOpen, selectedUser: selectedRowsData
            })
        }
    };

    const handleReSetPasswordClick = async (item) => {
        setIsResetPwModalOpen(true);
        setResetPwItem(item);
        setPasswordInputValue('')
    }
    const validatePassword = (password) => {
        const isLengthValid = password.length >= 8 && password.length <= 16;
        const hasSpecialCharacter = /[!@#$%^&*()_+{}[\]:;<>,.?~\\-]/.test(password);
        const hasCapitalLetter = /[A-Z]/.test(password);
        return isLengthValid && hasSpecialCharacter && hasCapitalLetter;
    };
    const handlePasswordInputChange = (e) => {
        setPasswordInputValue(e.target.value);
        setPasswordRegexError(!validatePassword(e.target.value));
    }
    const submitReSetPasswordClick = async () => {
        if (passwordRegexError) {
            return;
        }
        Swal.fire({
            html: 'Are you sure you want to reset the password for the user <b>' + resetPwItem.name + '</b>?',
            icon: "warning",
            confirmButtonText: 'Reset',
            showDenyButton: true,
            denyButtonText: 'Cancel',
            customClass: {
                actions: 'my-actions',
                cancelButton: 'order-2 right-gap',
                confirmButton: 'order-1',
                denyButton: 'order-3',
            },
        }).then(async (result) => {
            if (result.isConfirmed) {
                setSubBtnDisabled(true)
                try {
                    const { data } = await api.post("/auth/RegeneratePassword", {
                        userId: resetPwItem.uniqueIdentifier,
                        password: passwordInputValue,
                    });
                    if (data.statusCode === 200) {
                        Swal.fire({
                            text: 'Password reset successfully',
                            icon: 'info',
                            timer: 3000,
                            timerProgressBar: true,
                        });
                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                }
                finally {
                    setIsResetPwModalOpen(false);
                    setResetPwItem(null);
                    setPasswordInputValue('')
                    setSubBtnDisabled(false)
                }
            }
        })
    };

    const breadcrumbItems = [
        { label: 'Home Page', url: '/' },
        { label: 'User Management' },
    ];

    return (
        <>
            <div className='right-content'>

                <BreadCrumb items={breadcrumbItems}></BreadCrumb>

                <div className='mid-box-wrap'>
                    <h4 className='sub-head'>User Management</h4>

                    <div className='sub-nav nav2'>
                        <div className='add-user'>
                            <div onClick={navigateToAdd}>
                                <img src='/Assets/add-user.svg' alt='Add User' />
                                <span className='add-text'>Add User</span>
                            </div></div>
                        <div className='add-user'>
                            <AddNewPop title='Bulk Operations' className='add-user'>
                                <div>
                                    <div onClick={handleDeleteButtonClick}>
                                        <span><img src='/Assets/delete-icon.svg' alt='Delete Icon' /></span>
                                        Delete
                                    </div>
                                    <div onClick={handleDactivateButtonClick}>
                                        <span><img src='/Assets/deactivate2.svg' alt='Deactivate Icon' /></span>
                                        Deactivate / Activate
                                    </div>
                                    <div onClick={() => setModalBulkAccessProps(true, selectedRowsData)}>
                                        <span><img src='/Assets/assign.svg' alt='Assign Access' /></span>
                                        Assign Access
                                    </div>
                                </div>
                            </AddNewPop></div>
                        <div className='add-user'>
                            <AddNewPop title='User Upload' className='add-user'>
                                <div >
                                    <div>
                                        <a href={excelFilePath} download>
                                            <span><img src='/Assets/download.svg' alt='Excel Icon' /></span>
                                            Download template
                                        </a>
                                    </div>
                                </div>
                                <div className='' onClick={() => setBulkModal(true)}>
                                    <span><img src='/Assets/excel.svg' alt='Excel Icon' /></span>
                                    Upload excel
                                </div>
                            </AddNewPop></div>
                    </div>
                    <TableUser needRefresh={tableRefresh} changeSelectedData={changeSelectedData} onSelectedRowsData={onRowsSelected}
                        handleReSetPasswordClick={handleReSetPasswordClick} />
                </div>
            </div>

            <BulkUserUploadModal isOpen={bulkModal} closeCallback={() => { setBulkModal(false); setTableRefresh(!tableRefresh) }} />

            <BulkAccess successCallBack={() => setChangeSelectedData(!changeSelectedData)} isOpen={modalBulkAccess.isOpen} selectedUser={modalBulkAccess.selectedUser}
                closeCallback={() => { setModalBulkAccessProps(false, null); setTableRefresh(!tableRefresh); }} />

            <Modal isOpen={isResetPwModalOpen}>
                <ModalHeader>
                    <h5 className="modal-title">Reset Password</h5>
                </ModalHeader>
                <ModalBody>
                    <label className="folder-btm-text">Password</label>
                    <input
                        type="text"
                        className="form-control folder-textbox"
                        placeholder='Enter new password'
                        value={passwordInputValue}
                        onChange={handlePasswordInputChange}
                    />
                    {passwordRegexError ?
                        <p className='error-message'> * Password must be 8 - 16 characters and have at least one capital letter, small letter and special character(! @#$ % ^ & *?.) </p>
                        : null}
                </ModalBody>
                <ModalFooter>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setIsResetPwModalOpen(false)}
                    >
                        Cancel
                    </button>
                    <button disabled={subBtnDisabled} type="button" onClick={submitReSetPasswordClick} className="btn btn-primary">
                        Reset
                    </button>
                </ModalFooter>
            </Modal>
        </>
    )
}

export default UserManagement;
